import styled from 'styled-components';

const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  background-color: grey;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 99;
  opacity: 0.3;
  text-align: center;

  .spinner-obj {
    display: inline-block;
    position: relative;
    width: 200px;
    height: 200px;
    top: calc(50% - 100px);
  }
  
  .spinner-obj div {
    box-sizing: border-box;
    display: block;
    position: absolute;
    width: 180px;
    height: 180px;
    margin: 20px;
    border: 20px solid #ddd;
    border-radius: 50%;
    animation: spinner-obj 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
    border-color: #ddd transparent transparent transparent;
  }

  .spinner-obj div:nth-child(1) {
    animation-delay: -0.45s;
  }

  .spinner-obj div:nth-child(2) {
    animation-delay: -0.3s;
  }
  
  .spinner-obj div:nth-child(3) {
    animation-delay: -0.15s;
  }

  @keyframes spinner-obj {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }

  .hidden {
    display: none;
  }
`;

export default { Wrapper };
